import { createFileRoute } from "@tanstack/react-router";
import DETransporter from "@/pages/landing/DETransporter";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/transporter-gebraucht/")({
  head: () => routeHead("/de/transporter-gebraucht/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DETransporter />
  );
}
